import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isObject from 'lodash/isObject';
import _isString from 'lodash/isString';
export function getImage(images) {
  if (_isNil(images)) {
    return null;
  }
  if (_isString(images)) {
    return images;
  }
  if (_isArray(images) && !_isEmpty(images)) {
    return images[0];
  }
  if (_isObject(images) && !_isEmpty(images)) {
    return images;
  }
  return null;
}